<template>
  <div class="listContainer">
    <div class="headerLine">
      <div class="btn btn-primary" v-on:click="goCreate">添加商品</div>
    </div>
    <div class="listView">
      <div class="listMainView">
        <div class="listTableView">
          <table class="table">
            <thead>
              <tr class="info">
                <th v-for="fn in displayFields" :key="fn" v-text="fieldVerboseName(fn)"></th>
                <th>最后更新时间</th>
                <th>删除</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="item.id">
                <td v-bind:class="{link: colIndex == 0}"
                    v-for="(fn, colIndex) in displayFields"
                    :key="fn"
                    v-text="modelAdapter.fieldTextDisplay(item, fn, fieldSpec)"
                    v-on:click="goDetail(index, colIndex == 0)">  
                </td>
                <td v-text="item.last_update_timestamp"></td>
                <td class="delete" v-on:click="doDelete(index)">删除</td>
              </tr>      
            </tbody>
          </table>
        </div>
          <nav>
            <ul class="pagination">
              <li v-if="pagination.has_previous" v-on:click="loadPageData(1)">
                <a href="javascript:void(0)" aria-label="Previous">
                  <span aria-hidden="true">首页</span>
                </a>
              </li>
              <li v-if="pagination.has_previous" v-on:click="loadPageData(pagination.previous_link)">
                <a href="javascript:void(0)" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li v-bind:class="{active: pagination.current_no == no}" v-for="no in pagination.page_links" v-on:click="loadPageData(no)" :key="no">
                <a href="javascript:void(0)" v-text="no">
                </a>
              </li>
              <li v-if="pagination.has_next" v-on:click="loadPageData(pagination.next_link)">
                <a href="javascript:void(0)" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
              <li v-if="pagination.has_next" v-on:click="loadPageData(pagination.page_cnt)">
                <a href="javascript:void(0)" aria-label="Next">
                  <span aria-hidden="true" v-text="'尾页（' + pagination.page_cnt + '）'"></span>
                </a>
              </li>
            </ul>
          </nav>
      </div>
      <div class="listSideMenu">
        <div class="listSearchView">
          <div class="input-group-control">
            <input type="text" class="form-control" placeholder="请输入关键词" v-model="keyword" />
          </div>
          <div class="input-group-btn" v-on:click="loadPageData(1)">
            <button class="btn btn-default" type="button" style="margin-top: 0">搜索</button>
          </div>
        </div>
        <div class="filter"
             v-for="filterField in filterFields" 
             :key="filterField['field_name']">
          <div class="filterTitle" v-text="filterField.verbose_name"></div>
          <div class="filterOptions">
            <div class="filterOption"
                 v-bind:class="{active: fieldData[filterField['field_name']] == null}"
                 v-on:click="setFilterOption(filterField['field_name'], null)">
              不限
            </div>
            <div class="filterOption"
                 v-for="option in fieldData[modelAdapter.fieldOptionName(filterField)]"
                 :key="option.id"
                 v-text="option.name"
                 v-bind:class="{active: option.id == fieldData[filterField['field_name']]}"
                 v-on:click="setFilterOption(filterField['field_name'], option.id)"
                 v-if="filterField['field_type'] != 'BooleanField'">
            </div>
            <div class="filterOption"
                 v-bind:class="{active: fieldData[filterField['field_name']] === true}"
                 v-on:click="setFilterOption(filterField['field_name'], true)"
                 v-if="filterField['field_type'] == 'BooleanField'">
              是
            </div>
            <div class="filterOption"
                 v-bind:class="{active: fieldData[filterField['field_name']] === false}"
                 v-on:click="setFilterOption(filterField['field_name'], false)"
                 v-if="filterField['field_type'] == 'BooleanField'">
              否
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import crudService from '../../service/crud.js'
import adapterService from '../../service/modeladapter.js'

export default {
  name: 'ModelListPage',
  props: {
    lowerAppName: String,
    lowerModelName: String,
    version: String,
    title: String
  },
  data: function () {
    return {
      service: null,
      modelAdapter: null,

      keyword: '',

      items: [],
      pagination: {
        current_no: 1,
        page_links: [1],
        page_cnt: 1,
        has_next: false,
        previous_link: 0,
        has_previous: false,
        next_link: 2
      },

      // 与Manager不同的是，List只需要可选字段的选项信息，不需要具体字段内容
      filterFields: [],  // fieldMeta列表
      displayFields: [],  // 字段名称列表
      fieldSpec: [],
      fieldData: {}
    }
  },
  methods: {
    setFilterOption: function (fieldName, value) {
      this.fieldData[fieldName] = value
      this.loadPageData(1)
    },
    fieldVerboseName: function (fieldName) {
      let verboseName = fieldName
      this.fieldSpec.forEach(function (fieldMeta) {
        if (fieldMeta['field_name'] === fieldName) {
          verboseName = fieldMeta['verbose_name']
        }
      })
      return verboseName
    },
    doDelete: function (index) {
      var that = this
      var cond = {}
      cond[this.lowerModelName + '_id'] = this.items[index].id
      this.service.deleteModel(cond, function () {
        alert('删除成功')
        that.items.splice(index, 1)
      })
    },
    goCreate: function () {
      this.$router.push('/' + this.lowerModelName + '/create/')
    },
    goDetail: function (index, rightCol) {
      if (rightCol) {
        this.$router.push('/' + this.lowerModelName + '/detail/' + this.items[index].id)
      }
    },
    loadFieldSpec: function (callback) {
      let that = this
      this.service.loadModelFieldSpec(function (data) {
        that.fieldSpec = data.field_spec
        that.displayFields = data.admin_list_display_fields
        that.fieldSpec.forEach(function (fieldMeta) {
          if (that.modelAdapter.field2ControlType(fieldMeta) === 'select') {
            let fieldOptionName = that.modelAdapter.fieldOptionName(fieldMeta)
            that.$set(that.fieldData, fieldOptionName, [])
            that.filterFields.push(fieldMeta)
            that.$set(that.fieldData, fieldMeta['field_name'], null)
          } else if (fieldMeta['field_type'] === 'BooleanField') {
            that.filterFields.push(fieldMeta)
            that.$set(that.fieldData, fieldMeta['field_name'], null)
          } else {
            that.$set(that.fieldData, fieldMeta['field_name'], fieldMeta['default_value'])
          }
        })
        callback()
      })
    },
    loadOptions: function (callback) {
      let that = this
      this.service.loadModelOptions(function (data) {
        Object.keys(data).forEach(function (key) {
          that.fieldData[key] = data[key]
        })
        callback()
      })
    },
    loadPageData: function (pageNo) {
      let that = this
      let params = {page_no: pageNo}
      this.filterFields.forEach(function (fieldMeta) {
        console.log(fieldMeta)
        console.log(that.fieldData[fieldMeta['field_name']])
        if (that.fieldData[fieldMeta['field_name']] != null) {
          params[fieldMeta['field_name']] = that.fieldData[fieldMeta['field_name']]
        }
      })
      if (this.keyword) {
        params.keyword = this.keyword
      }
      this.service.getModelList(params, function (data) {
        that.items = data.items
        that.pagination = data.pagination_data
      })
    }
  },
  created: function () {
    let that = this
    this.service = new crudService.ModelService(this.lowerAppName,
            this.lowerModelName, this.version)
    this.modelAdapter = new adapterService.ModelAdapter()

    this.loadFieldSpec(function () {
      that.loadOptions(function () {
        that.loadPageData(1)
      })
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.listContainer {
  padding: 20px;
}
.listView {
  margin-top: 30px;
  display: flex;
}
.listMainView {
  flex-grow: 4;
}
.listSideMenu {
  width: 200px;
  padding-left: 5px;
}
.listSearchView {
  display: flex;
}
.listSearchView .input-group-control {
  flex-grow: 1;
  overflow: hidden;
}
.listSearchView .input-group-btn {
  width: 80px;
  overflow: hidden;
}
.listSearchView .input-group-btn button {
  width: 100%;
}
td.link {
  color: #1488F5;
  cursor: pointer;
}
td.delete {
  color: red;
  cursor: pointer;
}
.filterTitle {
  text-align: center;
  font-size: 14px;
  padding: 5px;
  color: black;
  font-weight: bold;
  background-color: #D9EDF7;
}
.filterOption {
  text-align: center;
  font-size: 12px;
  color: #333;
  padding: 3px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}
.filterOption.active {
  background-color: #f3f3f3;
  font-weight: bold;
}
.filterOption:hover {
  background-color: #f6f6f6;
}
</style>



// WEBPACK FOOTER //
// ModelListPage.vue?2b4f8908